import { DynamicRouteDataMap } from '@modules/navigation/models';

import { accountConfigs } from './account.data';
import { adminConfigs } from './admin.data';
import { authConfigs } from './auth.data';
import { demoConfigs } from './demo.data';
import { errorConfigs } from './error.data';
import { landingPageConfigs } from './landing-page.data';
import { allLegal } from './legal.data';
import { siteConfigs } from './site.data';

export const routeData: DynamicRouteDataMap = {
    ...accountConfigs,
    ...allLegal,
    ...adminConfigs,
    ...authConfigs,
    ...demoConfigs,
    ...errorConfigs,
    ...landingPageConfigs,
    ...siteConfigs,
};
